const actions = {
  async retrieveStructuresList(context) {
    const { data } = await this.$services.structure.findAll({});
    context.commit('updateStructuresList', data);
  },
};

export default actions;
